import { useTranslation } from "react-i18next";
import PageTitle from "components/ui/PageTitle";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="page-view not-found-page">
      <div className="page-view-content inner">
        <PageTitle title={t("pagetitles:NotFoundPage.Title")} subtitle={t("pagetitles:NotFoundPage.Subtitle")} />
      </div>
    </div>
  );
}
